import React, { Component } from 'react';
import { Link } from 'react-router-dom';


class LoginOptions extends Component {
	render() {
		return (
			<div>
				<div className="banner section light-translucent-bg">
					<div className="container">
						<h2>Collection Pack Ordering & Test Requisitions</h2>
						<div className="alert alert-info">
							<p>You are not logged in or your session has expired.</p>
						</div>
						<div>Please select the approprate link to login.</div>
						<ul>
							<li>
								<a href={'/mygdx/login' + (this.props.redirect ? '?url=' + this.props.redirect : '')}>
									Practitioner login
								</a>
							</li>
							<li>
								<Link to={"/register"}>Patient Registration</Link>
							</li>
						</ul>
					</div>
				</div>
			</div>
		);
    }

}
export default LoginOptions;